import axios from "axios"
import ApiService from "./ApiService"

class RegistriesApiService extends ApiService {
	static async getRegistry(registryId, organizationId, page = 0) {
		const { data } = await axios.get(`${super.getBaseUrl()}/organizations/${organizationId}/registries/${registryId}`, {
			params: {
				page
			}
		})
		return await data
	}
}

export default RegistriesApiService



// WEBPACK FOOTER //
// ./src/api/RegistriesApiService.js